import React, { Component } from 'react'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";
import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import { URL } from '../api';



export default class Header extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      nameuser: '',
      admin_type: '',
      Username: '',
      collapse: false,
      isWideEnough: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }
  
    

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }



    componentDidMount() {
      //  const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('name') !== "") {
          this.setState({ nameuser: localStorage.getItem('name') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })

        }

         // this.setState({ nameuser: localStorage.getItem('nameuser') })
         // this.setState({ admin_type: localStorage.getItem('admin_type') })
      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://luckyresortkpp.com/luckyresortkpp/'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }



    render() {



        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Check"><MDBIcon icon="file-alt" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Pagework"><MDBIcon far icon="user-circle" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem >
                 <MDBNavLink to="/Pageworkgraphic"><MDBIcon icon="home" /> ฝ่ายกราฟฟิก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacture"><MDBIcon icon="home" /> ฝ่ายพิมพ์</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufactureinstall"><MDBIcon icon="home" /> ฝ่ายติดตั้ง/ช่าง</MDBNavLink>
            </MDBNavItem>

            <MDBNavItem >
                 <MDBNavLink to="/Pageworkuserwait"><MDBIcon icon="spinner" /> รอดำเนินการ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkusercancel"><MDBIcon icon="ban" /> ยกเลิกใบสั่ง</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkreport"><MDBIcon icon="user-circle" /> รายงานสรุปจำนวน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkreportpay"><MDBIcon far icon="address-card" /> รายงานการเงิน</MDBNavLink>
            </MDBNavItem>

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        let user
        user = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/Homelucky"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Roommanagement"><MDBIcon icon="home" /> จัดการห้อง</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Roomshowstatus"><MDBIcon icon="home" /> สถานะเข้าพัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/RoomReport"><MDBIcon icon="home" /> รายงานผู้เข้าพัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/RoomReportmoney"><MDBIcon icon="home" /> รายงานการเงินเป็นช่วง</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/RoomReportmoneyday"><MDBIcon icon="home" /> รายงานการเงินรายวัน</MDBNavLink>
            </MDBNavItem>
           
            {/* <MDBNavItem >
                 <MDBNavLink to="/Pageworkuserwait"><MDBIcon icon="home" /> รอดำเนินการ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkusercancel"><MDBIcon icon="home" /> ยกเลิกใบสั่ง</MDBNavLink>
            </MDBNavItem> */}
           
            {/* <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacture"><MDBIcon icon="home" /> ฝ่ายผลิต</MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>

        )


        let graphic
        graphic = (
          <>
           <MDBNavItem >
                 <MDBNavLink to="/Pagework"><MDBIcon far icon="user-circle" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkgraphic"><MDBIcon icon="home" /> รายการกราฟฟิก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkgraphicreport"><MDBIcon icon="calendar-check" /> รายการประวัติส่งผลิต/พิมพ์</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacture"><MDBIcon icon="home" /> ฝ่ายพิมพ์</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufactureinstall"><MDBIcon icon="home" /> ฝ่ายติดตั้ง/ช่าง</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let pp
        pp = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacture"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacture"><MDBIcon icon="home" /> ฝ่ายพิมพ์</MDBNavLink>
            </MDBNavItem>  */}
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufacturereport"><MDBIcon icon="home" /> รายการประวัติส่งติดตั้ง</MDBNavLink>
            </MDBNavItem> 
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkmanufactureinstall"><MDBIcon icon="home" /> ฝ่ายติดตั้ง/ช่าง</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Pageworkinstallrereport"><MDBIcon icon="home" /> รายการประวัติติดตั้งเสร็จ</MDBNavLink>
            </MDBNavItem> 
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        // let expert
        // expert = (
        //   <>
        //     <MDBNavItem >
        //          <MDBNavLink to="/expert"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
        //     </MDBNavItem>
        //     {/* <MDBNavItem >
        //          <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink>
        //     </MDBNavItem> */}
        //      <MDBNavItem onClick={this.logout} >
        //       <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
        //     </MDBNavItem>
        //   </>
        // )
    


        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem  >
              <MDBNavLink to="/">   ส่งผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   ตรวจสอบผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   กติกาและข้อมูล </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   แอปพลิเคชัน </MDBNavLink>
            </MDBNavItem> */}
           
            {/* <MDBNavItem  >
              <MDBNavLink to="/main/LoginPages">  เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem> */}
          
          </>
        )

        const name = this.state.nameuser;

        return (
            <>
                <MDBNavbar color="primary-color-dark" dark expand="md" >
                    <MDBNavbarBrand>
                    
                        <strong className="white-text"><MDBIcon icon="globe-africa" /> luckyresortkpp</strong>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" onCollapse={(e)=>{console.log(e)}} isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}
                      {/* { localStorage.getItem('name') == null ? <>
                      {publics}
                     {window.location.href = '/tess'} 
                      </>:<>
                       {this.state.admin_type === '2' ? <>
                                      {superadmin}
                                      </> : null}
                      </>} */}
                                                
                                      {this.state.admin_type === '1' ? <>
                                      {superadmin}
                                      </> : null}

                                      {this.state.admin_type === null ? <>
                                      {publics}
                                      </> : null}

                                      {this.state.admin_type === '2' ? <>
                                      {user}
                                      </> : null}  

                                      {this.state.admin_type === '3' ? <>
                                      {graphic}
                                      </> : null}  

                                      {this.state.admin_type === '4' ? <>
                                      {pp}
                                      </> : null}  
                              

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                <MDBFormInline waves>
                                    <div className="md-form my-0">
                                        {/* <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" /> */}
                                        {/* <MDBNavLink to=""><MDBIcon icon="home" /> {this.name} </MDBNavLink> */}
                                    </div>
                                </MDBFormInline>
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBNavbar>



            </>
        )
    }
}

